export default __webpack_public_path__ + "static/kingam-688a5f10998f859c995df0845506a2b5.png";